import React from 'react';
import useIsMobile from '../services/useIsMobile';
import BaseButton from "./BaseButton";
import arrowLeft from "../assets/fi_chevron-left.svg";
import phone from "../assets/fi_phone_black.svg";

export default function CallButton({ userPhone, handleLogin, showError, setShowCallButton, setPhone }) {
    const isMobile = useIsMobile();
    const phoneNumber = '+370 (5) 278 9918';

    return (
        <>
            <p>Prašome paskambinti iš savo numerio {userPhone}. Skambutis bus automatiškai atmestas ir mokestis nebus taikomas.</p>
            {isMobile ? (
                <a href={`tel:${phoneNumber}`} className={'callButtonLink'}>
                    <BaseButton text={'Skambinti'} className={'baseButton--hasIconCenter baseButton--primary'} icon={phone} />
                </a>
            ) : (
                <p>Paskambinkite į tel. nr. {phoneNumber}</p>
            )}
            <p>Jeigu jau paskambinote, spauskite Prisijungti</p>
            <BaseButton text={'Prisijungti'} handleOnClick={handleLogin} className={'baseButton--primary'}/>
            <BaseButton
                className={'baseButton--secondary'}
                text={'Atgal'}
                handleOnClick={() => {
                    setShowCallButton(false)
                    setPhone('');
                }}
                icon={arrowLeft}
                iconClassName={'baseButton__iconLeft'}
            />

            {showError && <p className={'error'}>Neatlikote skambučio</p>}
        </>
    );
}